import axios from 'axios'

const transparentImage = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
const noImagePlaceholder = '/images/technosuccess-placeholder.svg';

const unloadClass = ( img, observer = null ) => {
    const loader = img.parentElement;
    loader?.classList.remove( 'image-placeholder_loading' );
    observer && observer.unobserve(img);
}

async function resizeImage(imageId, width, height, pad = true) {
  const resized = { src: '', srcset: '' };

  if (!width || !height || !imageId)
    return resized;

  const formData = new FormData();
  formData.append('width', width.toString());
  formData.append('height', height.toString());
  if (!pad) {
    formData.append('pad', '0');
  }

  try {
    const res = await axios.post(`/images/${imageId}/resize/`, formData);
    if (res.data.url) {
      resized.src = res.data.url;
      // srcset строим только по hires_url от сервера: он приходит, лишь когда 2x-нарезка
      // реально создана. Раньше URL 2x вычислялся заменой размеров в пути 1x — если 2x не
      // был разрешён или упал, браузер на HiDPI выбирал несуществующий файл и ловил 404.
      if (res.data.hires_url) {
        resized.srcset = `${res.data.url} 1x, ${res.data.hires_url} 2x`;
      }
    }
  } catch (err) {
    resized.src = noImagePlaceholder;
    console.error('Resize failed', `${imageId}: ${width}x${height}` );
  }

  return resized;
}

const observer = new IntersectionObserver((entries, obs) => {
  entries.forEach(async entry => {
      if (!entry.isIntersecting)
          return;
        
      const img = entry.target;
      const loader = img.parentElement;
      const loadingClass = 'image-placeholder_loading';      

      //img.getAttribute('src') == noImagePlaceholder
      if (img.dataset.processed == 'true' ) {
        unloadClass(img, obs);
        return;
      }

      const imageId = parseInt(img.dataset.imageId);
      const width = parseInt(img.dataset.width, 10);
      const height = parseInt(img.dataset.height, 10);

      // Cart temporary lazy loading fix
      if( isNaN( imageId ) || !imageId ) {
          if( img.dataset.placeholder ) {
            img.src = img.dataset.placeholder;
          } else if( img.src ) {
            const tryImage = new Image();
            tryImage.onload = () => { 
              img.dataset.processed = 'true'
              img.src = tryImage.src;
            }
            tryImage.onerror = () => {
              img.dataset.processed = 'true'
              img.src = img.dataset.placeholder;
            }
            tryImage.src = img.src;
            img.src = transparentImage;
          }

          return;
      }

      img.dataset.processed = 'true'

      // Уже показываем настоящий файл? Тогда неудачный резайз не повод его портить.
      // Сервер отдаёт готовый 1x даже когда не хватает 2x, и подмена плейсхолдером
      // в catch'е делала картинку хуже, чем она была до запроса.
      const hasVisibleImage = Boolean(img.currentSrc || img.src)
        && !img.src.startsWith('data:')
        && img.src !== img.dataset.placeholder;

      const resized = await resizeImage(imageId, width, height);

      if (resized.src === noImagePlaceholder && hasVisibleImage) {
        unloadClass(img, obs);
        return;
      }

      if (resized.src) {
        const tmpImage = new Image();
        tmpImage.onload = () => {
          unloadClass(img, obs);
          img.src = tmpImage.src;
          if( resized.srcset ) {
            img.srcset = tmpImage.srcset;
          }
        }

        tmpImage.onerror = () => loader?.classList.remove( loadingClass )
        tmpImage.src = resized.src;

        if( resized.srcset ) {
            tmpImage.srcset = resized.srcset;
        }
      }        
    },
  )
}, {
  rootMargin: '100px',
  threshold: 0.1,
})

export { observer, resizeImage };